import { UniswapFee, UniswapFees } from "./generated"

export const getValidFees = (): UniswapFee[] => {
  return [UniswapFees.LOW, UniswapFees.MEDIUM]
}
